import React from "react";
import { useTranslation } from "../hooks/hooks";
import { IGame } from "../interfaces/intefaces";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routes } from "../router/Routes";
import { currentGameAtom, gameofWeekAtom, userIsLoggedInAtom } from "../state/games";
import { useAtom } from "jotai";

const GameofWeek = () => {
    const { _e } = useTranslation();
    const [userIsLoggedIn] = useAtom(userIsLoggedInAtom);
    const [, setCurrentGame] = useAtom(currentGameAtom);
    const [game] = useAtom(gameofWeekAtom);
    const navigate = useNavigate();
    const handleGameClick = (
        game: IGame,
        userIsLoggedIn: boolean,
        loginRequired: boolean,
        for_fun_supported: number,
    ) => {
        if (!userIsLoggedIn && loginRequired) {
            const el = document.getElementById("login-button");
            if (el !== null) {
                el.click();
            }
            return false;
        }
        setCurrentGame(game);
        const url = new URL(game.url);
        navigate(
            `${routes.pages.game}?${url.searchParams.toString()}&plat_user=${game.pu}&for_fun=${for_fun_supported}`,
        );
        return true;
    };

    return (
        <div className="game-of-week">
            <h2>{_e("GAME OF THE WEEK")}</h2>
            {game && (
                <div className="game">
                    <img src={`${game.gmi[0]}/gamelogo`} />
                    <span className="title">{game.pt}</span>
                    <Button
                        variant="outlined"
                        type="button"
                        className="btn-primary load_more"
                        onClick={() => handleGameClick(game, userIsLoggedIn, true, 0)}
                    >
                        {_e("PLAY NOW")}
                    </Button>
                    <br />
                    <br />
                    {game.ffs === 1 && (
                        <Button
                            variant="text"
                            onClick={() => handleGameClick(game, userIsLoggedIn, false, 1)}
                        >
                            {_e("PLAY FOR FUN")}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

export default GameofWeek;
